import React from 'react'
import type { TdHTMLAttributes } from 'react'

interface Props
  extends Required<Pick<TdHTMLAttributes<HTMLTableCellElement>, 'colSpan'>> {
  children: React.ReactNode
}

const TableFullContent: React.FC<Props> = ({ colSpan, children }: Props) => {
  const base = 'tbody'

  return (
    <tr className={`${base}__row--full-content`}>
      <td colSpan={colSpan} className={`${base}__cell table__cell--w100`}>
        {children}
      </td>
    </tr>
  )
}

export default TableFullContent
